import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=3ccf5de2&"
import script from "./basicInfo.vue?vue&type=script&lang=ts&"
export * from "./basicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./basicInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports